// extracted by mini-css-extract-plugin
export default {"loader":"UatWR2Cjoi67ieT","load":"ljCSHBX6qddaO9g"};